/**
 * @prettier
 */
export const CardBrands = {
    VISA: 'VISA',
    MASTERCARD: 'MASTERCARD',
    AMERICAN_EXPRESS: 'AMERICAN_EXPRESS',
    CARNET: 'CARNET',
    EDENRED: 'EDENRED',
    SODEXO: 'SODEXO',
    PRIVADA: 'PRIVADA',
    UNKNOWN: 'UNKNOWN',
} as const;

export type CardBrand = typeof CardBrands[keyof typeof CardBrands] | string;
